export const SET_CONTACTS = 'contacts/SET_CONTACTS';
export const APPEND_CONTACTS = 'contacts/APPEND_CONTACTS';
export const RESET_CONTACTS = 'contacts/RESET_CONTACTS';
export const REPLACE_CONTACT = 'contacts/REPLACE_CONTACT';
